/**@jsx jsx */
import { css, jsx } from '@emotion/core'
import ContactInfo from './ContactInfo';

const AppBar = () => {

  const appBarDiv = css`
  height: 9em;
  direction: rtl;
  background-color: #cfd3d161;
  font-family: Segoe UI;
  padding-bottom: 0.5em;
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 820px) {
    flex-direction: column;
    height: 20%;
  }
  `;

  const imgStyle = css`
  position: relative;
  height: 8em;
  width: 17%;
  margin-top: 2%;
  @media only screen and (max-width: 820px) {
    width: 50%;
    right: 25%;
  }
  `;

  const contactStyle = css`
  display: flex;
  flex-direction: row-reverse;
  grid-gap: 20px;
  margin-top: 15%;
  padding-left: 10px;
  @media only screen and (max-width: 820px) {
    margin-bottom: 2%;
  }
  @media only screen and (max-width: 705px) {
    display: grid;
    grid-template-columns: 52% 52%;
    padding: 2%;
    grid-template-rows: 52%;
    grid-auto-rows: 52%;
    grid-gap: 7%;
    justify-content: center;
    margin-top: 0;
  }
  `;

  return (
    <div css={appBarDiv}>
      <img alt={''} css={imgStyle} src={require('../pictures/logo2.png')} />
      <ContactInfo cssContactInfo={contactStyle} />
    </div>
  );
}

export default AppBar;
